<div id="sidebar" (window:resize)="onResize()" [attr.data-slim]="isSlim">
  <div class="sidebar-content">
    <div class="sidebar-logo">
      <a title="{{ 'navigation.home' | translate }}" routerLink="/home">
        <span class="sr-only">{{ 'navigation.home' | translate }}</span>
      </a>
    </div>
    
    <div class="maintenance-mode" *ngIf="runningMaintenanceWindow$ | async">
      <div class="inner">
        <a routerLink="/home" title="{{ 'navigation.home' | translate }}" attr.aria-label="{{ 'navigation.home' | translate }}">
          <i class="fas fa-tools" aria-hidden="true"></i>
          <span>
            {{ 'components.navbar.maintenanceMode' | translate }}
          </span>
        </a>
      </div>
    </div>

    <div class="sidebar-main">
      <div class="profile" *ngIf="!isSlim">
        <div class="claim">
          {{ 'navigation.logoSubTitle' | translate }}
        </div>
        <div class="profile_info">
          <div>
            {{ 'navigation.salutation' | translate }}
            <div class="name"> {{ loggendInUser }}</div>
          </div>
        </div>
      </div>

      <app-sidebar-nav [slim]="isSlim" [ariaLabel]="'navigation.aria.navigation' | translate">
        <app-sidebar-nav-section [label]="'navigation.search.header' | translate" logoClass="fas fa-search">
          <app-sidebar-nav-section-link [label]="'navigation.search.simple' | translate" routerLink="/search/simple" />
          <app-sidebar-nav-section-link [label]="'navigation.search.citation' | translate" routerLink="/search/citation" />
          <app-sidebar-nav-section-link [label]="'navigation.search.species' | translate" routerLink="/search/species" />
          <app-sidebar-nav-section-link [label]="'navigation.search.advanced' | translate" routerLink="/search/advanced" />
          <app-sidebar-nav-section-link [label]="'navigation.search.expert' | translate" routerLink="/search/expert" />
        </app-sidebar-nav-section>
        <app-sidebar-nav-section [label]="'navigation.create.header' | translate" logoClass="fas fa-plus">
          <app-sidebar-nav-section-link [label]="'navigation.create.dossier' | translate" routerLink="/dossier/substance/create" *appHasRight="[Rights.StoffErstellen]" />
          <app-sidebar-nav-section-link [label]="'navigation.create.citation' | translate" routerLink="/dossier/citation/create" />
          <app-sidebar-nav-section-link [label]="'navigation.create.species' | translate" routerLink="/dossier/species/create" *appHasRight="[Rights.SpeziesVerwalten]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.favoritenlisten' | translate" routerLink="/lists" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.dataModelEditor' | translate" href="{{ dataModelEditorUrl }}" *appHasRight="[Rights.Datenmodellaenderung]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.rules' | translate" routerLink="/rules" *appHasRight="[Rights.ValidierungsregelkatalogLesen]" />
          <app-sidebar-nav-section-link [label]="'ranking.title' | translate" routerLink="/ranking" *appHasRight="[Rights.RankingLesen]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.thesaurus' | translate" routerLink="/thesaurus" *appHasRight="[Rights.ThesaurusregelkatalogLesen]" />
          <app-sidebar-nav-section-link [label]="'components.lookup.title' | translate" routerLink="/lookuptables" />
          <app-sidebar-nav-section-link [label]="'psatz.title' | translate" routerLink="/psatz" *appHasRight="[Rights.PSatzRegeltabellenLesen]"/>
        </app-sidebar-nav-section>
        <app-sidebar-nav-section [label]="'navigation.administration.header' | translate" logoClass="fas fa-cogs">
          <app-sidebar-nav-section-link [label]="'navigation.administration.entries' | translate" routerLink="/erfassungen" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.export' | translate" routerLink="/export" *appHasRight="[Rights.ExporteLesen]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.import' | translate" routerLink="/import" *appHasRight="[Rights.ImporteLesen]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.system' | translate" routerLink="/system-settings" *appHasRight="[Rights.SystemeinstellungenChemInfoAendern]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.maintenance' | translate" routerLink="/maintenance" *appHasRight="[Rights.WartungsfensterLesen]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.recherche' | translate" href="{{ rechercheUrl }}" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.usermanagement' | translate" href="{{ userManagementUrl }}" *appHasRight="[Rights.NutzerverwaltungLesen]" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.manageUser' | translate" href="{{ manageUserUrl }}" />
          <app-sidebar-nav-section-link [label]="'navigation.administration.changePassword' | translate" href="{{ changePasswordUrl }}" />
        </app-sidebar-nav-section>
        <app-sidebar-nav-section [label]="'navigation.feedback.header' | translate" logoClass="far fa-comments">
          <app-sidebar-nav-section-link [label]="'navigation.feedback.feedbacklist' | translate" routerLink="/feedback" />
        </app-sidebar-nav-section>
      </app-sidebar-nav>

      <div class="sidebar-buttons" *ngIf="isSlim">
        <button (click)="openCommonFeedback()" id="btn_global_feedback" 
          title="{{ 'navigation.feedback.giveSystemFeedback' | translate }}"
          [attr.aria-label]="'navigation.feedback.giveSystemFeedback' | translate" aria-haspopup="dialog">
          <i class="far fa-comment" aria-hidden="true"></i>
          {{ 'navigation.feedback.giveFeedback' | translate }}
        </button>
        <button (click)="openFavoriten()" id="btn_favoriten"
          title="{{ 'components.favoriten.title' | translate }}"
          [attr.aria-label]="'components.favoriten.title' | translate" aria-haspopup="dialog">
          <i class="far fa-star" aria-hidden="true"></i>
          {{ 'components.favoriten.buttonLabel' | translate }}
        </button>
        <button (click)="signOut()" id="btn_sign-out">
          <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
          {{ 'components.navbar.signout' | translate }}
        </button>        
      </div>
    </div>

    <div class="sidebar-footer" *ngIf="!isSlim">
      <div class="sidebar-footer-action-wrapper">
        <button (click)="openCommonFeedback()" id="btn_global_feedback"
          title="{{ 'navigation.feedback.giveSystemFeedback' | translate }}"
          [attr.aria-label]="'navigation.feedback.giveSystemFeedback' | translate" aria-haspopup="dialog">
          <i class="far fa-comment" aria-hidden="true"></i>
        </button>
        <button (click)="openFavoriten()" id="btn_favoriten"
          title="{{ 'components.favoriten.title' | translate }}"
          [attr.aria-label]="'components.favoriten.title' | translate" aria-haspopup="dialog">
          <i class="far fa-star" aria-hidden="true"></i>
        </button>
        <!--<a routerLink="/settings" title="{{ 'components.navbar.settings' | translate }}">
          <span class="fas fa-cog" aria-hidden="true"> </span>
        </a>-->
      </div>
      <div class="sidebar-footer-action-wrapper">
        <button (click)="signOut()" id="btn_sign-out" title="{{ 'components.navbar.signout' | translate }}"
          [attr.aria-label]="'components.navbar.signout' | translate">
          <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>